import { RootState } from "../reducers";

export const getDashboardLayers = ({ dashboard }: RootState) => dashboard?.layers;
